import React, { useState } from 'react';
import './bankPaymentDrawer2.scss';
import BankPaymentContent from './BankPaymentContentS2';
import BankPaymentContentS2 from './BankPaymentContentS2';
import useMobileVhFix from '../../../hooks/height';

const BankPaymentDrawerS2 = ({
  cancel,
  setTipsDrawerActive,
  activeOrder,
  setActiveOrder,
}) => {
  useMobileVhFix();

  return (
    <div className="bank-payment-drawer2">
      <div className="shadow" onClick={cancel}></div>
      <BankPaymentContentS2
        setTipsDrawerActive={setTipsDrawerActive}
        cancelClick={cancel}
        activeOrder={activeOrder}
        setActiveOrder={setActiveOrder}
      />
    </div>
  );
};

export default BankPaymentDrawerS2;
